/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED API METHODS - DO NOT EDIT
 * Generated from: MerchantDashboardContract
 */

import { apiClient } from '../../utils/api-client';
import type {
  GetDashboardParamsType,
  GetDashboardResponseType,
  MessageResponse,
} from '@zlinkx/shared-v2';

export const merchantdashboardApi = {
  getDashboard: async (
    merchantId: GetDashboardParamsType['merchantId']
  ): Promise<GetDashboardResponseType> => {
    return apiClient.get<GetDashboardResponseType['data']>(`/merchants/${merchantId}/dashboard`) as Promise<GetDashboardResponseType>;
  },
};